"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  gradient,
  ...props
}) => {
  const iconSharedUtils = require('./utils/icon-shared-utils');
  const hasGradient = iconSharedUtils.hasValidGradient(gradient);
  let fillValue = color;
  let gradientDefs;
  let gradientUtils;
  if (hasGradient) {
    gradientUtils = iconSharedUtils.getGradientUtils();
    const iconWebUtils = require('./utils/icon-web-utils');
    const gradientId = gradientUtils.generateGradientId(gradient);
    fillValue = `url(#${gradientId})`;
    gradientDefs = iconWebUtils.renderWebGradientDefs(gradient, gradientId);
  }
  const svgContent = (0, _jsxRuntime.jsxs)("svg", {
    ...props,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    fill: fillValue,
    role: title ? 'img' : undefined,
    "aria-hidden": !title,
    "aria-labelledby": titleId,
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      id: titleId,
      children: title
    }) : null, (0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      d: "m20.902 2.592-.07-.075-.005-.005a.601.601 0 0 0-.399-.153H3.571l-.1.01h-.008a.596.596 0 0 0-.36.219L.126 6.365l-.05.075-.003.007a.598.598 0 0 0-.064.363.342.342 0 0 0-.01.078v.154l.005.202a4.06 4.06 0 0 0 3.141 3.74v10.06l.008.1.002.007c.05.278.293.49.587.49h16.515l.1-.009.007-.001a.598.598 0 0 0 .489-.587v-10.06l.135-.033a4.055 4.055 0 0 0 3.01-3.909L24 6.888l-.005-.041-.002-.09v-.006a.589.589 0 0 0-.116-.287l-2.975-3.872Zm-8.305 3.7h4.361l-1.369-2.74h-2.992v2.74Zm-8.53 3.61a2.878 2.878 0 0 1-2.823-2.417h4.261v2.01l-.138.078a2.806 2.806 0 0 1-1.3.329Zm2.632-.19a2.872 2.872 0 0 0 2.326 1.195c.9 0 1.736-.418 2.279-1.13l.099-.139V7.485H6.699v2.228ZM4.34 11.08l.174-.014h.003c.48-.056.946-.2 1.389-.43a4.029 4.029 0 0 0 3.12 1.464c1.14 0 2.21-.47 2.977-1.297a4.06 4.06 0 0 0 2.972 1.297 4.023 4.023 0 0 0 3.119-1.464 3.981 3.981 0 0 0 1.567.446v9.364h-.379V13.18l-.008-.1-.002-.007a.597.597 0 0 0-.587-.49H13.18l-.1.008-.007.002a.598.598 0 0 0-.49.587v7.268H4.339V11.08Zm13.748 9.367h-4.311v-6.67h4.311v6.67Zm-3.113-9.54a2.857 2.857 0 0 1-2.377-1.268V7.485H17.3V9.71l-.098.13a2.87 2.87 0 0 1-2.23 1.067Zm3.52-1.41a2.84 2.84 0 0 0 1.438.406c1.38 0 2.56-1.005 2.81-2.338l.012-.08h-4.26v2.011ZM3.861 3.551h3.215l-1.37 2.74H1.704l2.157-2.74Zm13.062 0h3.212l2.103 2.74h-3.946l-1.369-2.74Zm-9.882 2.74 1.37-2.74h2.992v2.74H7.04Zm5.163 6.887-.01-.1v-.008a.598.598 0 0 0-.588-.488h-6.29l-.1.008-.008.001a.597.597 0 0 0-.49.587v3.932l.009.1.001.007c.05.278.295.49.587.49h6.291l.1-.008.008-.001a.598.598 0 0 0 .49-.588v-3.93Zm-1.194.597v2.738H5.912v-2.738h5.098Z",
      clipRule: "evenodd"
    })]
  });
  return hasGradient ? gradientUtils.addGradientToSvg(svgContent, gradientDefs) : svgContent;
};